import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPremiumDiamond = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5642_493)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.9985 5.15488C14.0018 5.13834 13.9985 5.12511 13.9985 5.10858C13.9985 5.08543 13.9952 5.06559 13.9886 5.04244C13.9853 5.02921 13.982 5.01598 13.9787 5.00276C13.9754 4.99945 13.9754 4.99283 13.9754 4.98953C13.9622 4.95976 13.9456 4.93331 13.9225 4.91016L11.4025 2.10582C11.343 2.03968 11.2537 2 11.1644 2H2.84071C2.74812 2 2.66214 2.03968 2.60261 2.10582L0.0859821 4.90685C0.0628331 4.93331 0.042991 4.95976 0.026456 4.99283C0.023149 4.99945 0.0231491 5.00606 0.0198421 5.01268C0.0165351 5.01929 0.016535 5.0259 0.013228 5.03252C0.00330699 5.06228 0 5.09535 0 5.12511V5.15157C0.003307 5.18795 0.00992097 5.22432 0.026456 5.2607C0.026456 5.26401 0.029763 5.26401 0.029763 5.26732C0.042991 5.29377 0.0562192 5.31692 0.0760612 5.34007L6.7562 12.7841C6.76281 12.794 6.77604 12.7974 6.78266 12.804C6.79919 12.8205 6.81903 12.8337 6.83888 12.8437C6.85541 12.8536 6.86864 12.8602 6.88517 12.8668C6.91163 12.8767 6.93809 12.8833 6.96785 12.8833C6.97777 12.8833 6.98769 12.8899 6.99761 12.8899C7.00423 12.8899 7.01415 12.8866 7.02076 12.8866C7.05383 12.8833 7.08359 12.8767 7.11336 12.8668C7.12658 12.8602 7.13981 12.8536 7.14973 12.847C7.17288 12.8337 7.19603 12.8172 7.21587 12.7974C7.22249 12.7907 7.2291 12.7907 7.23572 12.7841L13.8927 5.36653C13.8927 5.36653 13.8927 5.36653 13.8927 5.36322L13.9125 5.34007C13.9258 5.32684 13.9324 5.31031 13.9423 5.29377C13.9555 5.27393 13.9655 5.25078 13.9754 5.22763C13.9886 5.19787 13.9952 5.17803 13.9985 5.15488ZM12.9634 4.79772H9.75565L8.78339 2.63825H11.0222L12.9634 4.79772ZM4.89767 5.43928H9.09756L7.00092 11.5705L4.89767 5.43928ZM4.94727 4.79772L5.91953 2.63825H8.079L9.05126 4.79772H4.94727ZM2.98291 2.63494H5.21845L4.24619 4.79441H1.0417L2.98291 2.63494ZM4.21973 5.43928L6.1874 11.1769L1.0384 5.43928H4.21973ZM7.81444 11.1736L9.7788 5.43597H12.9634L7.81444 11.1736Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5642_493",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.000976562)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPremiumDiamond);
export default ForwardRef;
